// Dados mockados da IPA Mobile
export const WHATSAPP_NUMBER = '5511989417725';

export const HERO_IMAGES = {
  main: 'https://images.pexels.com/photos/32942100/pexels-photo-32942100.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  quality: 'https://images.unsplash.com/photo-1755370530232-aaaab3dd9b9c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwzfHxpcGhvbmUlMjBwYXJ0cyUyMGNvbXBvbmVudHN8ZW58MHx8fHwxNzc2NTk2MDkyfDA&ixlib=rb-4.1.0&q=85',
  technology: 'https://images.pexels.com/photos/6755056/pexels-photo-6755056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  trust: 'https://images.pexels.com/photos/32391502/pexels-photo-32391502.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940'
};

export const STATS = [
  { number: '15.000+', label: 'iPhones Atendidos', icon: 'Package' },
  { number: '10.000+', label: 'Clientes Satisfeitos', icon: 'Users' },
  { number: 'Até 12 meses', label: 'de Garantia', icon: 'Shield' },
  { number: 'Imediato', label: 'Atendimento WhatsApp', icon: 'Clock' }
];

export const SERVICES = [
  {
    id: 'display',
    title: 'Displays Premium',
    icon: 'Smartphone',
    description: 'Telas OLED com cores idênticas ao original',
    features: ['Touch 100% funcional', 'Cores vibrantes', 'Encaixe perfeito'],
    popular: true,
    image: HERO_IMAGES.quality
  },
  {
    id: 'battery',
    title: 'Baterias de Alta Capacidade',
    icon: 'Battery',
    description: 'Células de energia com performance original',
    features: ['Duração prolongada', 'Carregamento rápido', 'Sem vício']
  },
  {
    id: 'back-glass',
    title: 'Vidros Traseiros',
    icon: 'Shield',
    description: 'Acabamento premium idêntico ao original',
    features: ['Acabamento perfeito', 'Resistência superior', 'Cores originais']
  },
  {
    id: 'camera',
    title: 'Câmeras e Sensores',
    icon: 'Camera',
    description: 'Lentes e sensores de alta precisão',
    features: ['Foco preciso', 'Cores naturais', 'Qualidade profissional']
  }
];

export const MODELS = [
  {
    id: 'iphone-11',
    name: 'iPhone 11',
    display: 'Consulte disponibilidade',
    battery: 'Consulte disponibilidade',
    backGlass: 'Consulte disponibilidade',
    popular: false
  },
  {
    id: 'iphone-12',
    name: 'iPhone 12 / Pro',
    display: 'Consulte disponibilidade',
    battery: 'Consulte disponibilidade',
    backGlass: 'Consulte disponibilidade',
    popular: false
  },
  {
    id: 'iphone-13',
    name: 'iPhone 13 / Pro',
    display: 'Consulte disponibilidade',
    battery: 'Consulte disponibilidade',
    backGlass: 'Consulte disponibilidade',
    popular: true
  },
  {
    id: 'iphone-14',
    name: 'iPhone 14 / Pro',
    display: 'Consulte disponibilidade',
    battery: 'Consulte disponibilidade',
    backGlass: 'Consulte disponibilidade',
    popular: true
  },
  {
    id: 'iphone-15',
    name: 'iPhone 15 / Pro',
    display: 'Consulte disponibilidade',
    battery: 'Consulte disponibilidade',
    backGlass: 'Consulte disponibilidade',
    popular: false
  }
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: 'Marcelo Lima',
    role: 'Cliente - São Paulo',
    text: 'Meu iPhone 13 estava com a tela quebrada há semanas. Entrei em contato pelo WhatsApp e em poucas horas já estava com meu celular funcionando perfeitamente! A qualidade da aplicação é impecável, parece novo.',
    rating: 5,
    avatar: 'M',
    date: 'Há 2 semanas'
  },
  {
    id: 2,
    name: 'Juliana Mendes',
    role: 'Cliente - Moema',
    text: 'A bateria do meu iPhone durava apenas 2 horas. Depois que a iPaMobile aplicou a bateria nova, voltou a durar o dia inteiro! O atendimento foi super rápido pelo WhatsApp e a equipe muito profissional. Super recomendo!',
    rating: 5,
    avatar: 'J',
    date: 'Há 1 mês'
  },
  {
    id: 3,
    name: 'Roberto Santos',
    role: 'Cliente - Pinheiros',
    text: 'Quebrei o vidro traseiro do meu iPhone 14 Pro. Achei que ia ficar horrível, mas o trabalho ficou PERFEITO! A garantia de até 12 meses me deixou super tranquilo. Melhor atendimento que já recebi!',
    rating: 5,
    avatar: 'R',
    date: 'Há 3 semanas'
  }
];

export const GARANTIAS = [
  {
    icon: 'ShieldCheck',
    title: 'Garantia de Até 12 Meses',
    description: 'Cobertura contra defeitos nas aplicações realizadas'
  },
  {
    icon: 'Package',
    title: 'Peças Premium',
    description: 'Componentes de alta qualidade testados e aprovados'
  },
  {
    icon: 'Truck',
    title: 'Atendimento Rápido',
    description: 'Resposta imediata no WhatsApp, sem espera'
  },
  {
    icon: 'BadgeCheck',
    title: 'Equipe Qualificada',
    description: 'Profissionais especializados em dispositivos Apple'
  }
];

export const URGENCY_MESSAGES = [
  '🔥 15 pessoas consultando preços agora mesmo',
  '⚡ Atendimento imediato disponível no WhatsApp',
  '✨ Aplicação profissional com garantia de até 12 meses',
  '🎯 Mais de 10.000 clientes já atendidos com sucesso'
];

export const BENEFITS = [
  {
    id: 1,
    icon: 'Clock',
    title: 'Atendimento Imediato',
    description: 'Resposta instantânea no WhatsApp'
  },
  {
    id: 2,
    icon: 'Shield',
    title: 'Garantia de até 12 meses',
    description: 'Cobertura completa para sua tranquilidade'
  },
  {
    id: 3,
    icon: 'Truck',
    title: 'Pronta Entrega',
    description: 'Estoque sempre disponível em SP'
  },
  {
    id: 4,
    icon: 'Award',
    title: 'Peças Premium',
    description: 'Componentes de qualidade original'
  }
];

export const FAQ = [
  {
    id: 1,
    question: 'As peças são de qualidade original?',
    answer: 'Trabalhamos com componentes premium de padrão original, com garantia de até 12 meses nas aplicações realizadas.'
  },
  {
    id: 2,
    question: 'Quanto tempo demora o atendimento?',
    answer: 'Temos pronta entrega em São Paulo. Atendimento no local com aplicação no mesmo dia, sem agendamento prévio em muitos casos.'
  },
  {
    id: 3,
    question: 'Como faço o pedido?',
    answer: 'Simples! Clique no botão WhatsApp, informe o modelo do seu dispositivo e receba a cotação instantânea.'
  },
  {
    id: 4,
    question: 'Vocês aplicam as peças no local?',
    answer: 'Sim! Temos ponto de atendimento em Chácara Santo Antônio, São Paulo, onde nossa equipe especializada realiza a aplicação dos componentes com garantia de até 12 meses. Fale conosco pelo WhatsApp para consultar disponibilidade e orçamento.'
  }
];

export const CONTACT_INFO = {
  address: 'Chácara Santo Antônio, São Paulo - SP',
  whatsapp: WHATSAPP_NUMBER,
  email: 'contato@ipamobile.com.br'
};
